import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import section7Data from './data/Section7Data'
import '../../index.css'

const Section7 = () => {
  const { ref: Section7Ref, inView: Section7InView } = useInView({ triggerOnce: true })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <motion.section
      className="flex justify-center py-20 min-h-[800px]"
      ref={Section7Ref}
      variants={fadeInUpVariant}
      initial="hidden"
      animate={Section7InView ? 'visible' : 'hidden'}
    >
      <div className="Section7-Container">
        {/* Heading */}
        <motion.h2
          className="Section7-Title  text-2xl md:text-4xl font-bold mb-5 text-black"
          variants={fadeInUpVariant}
          transition={{ delay: 0.2 }}
        >
          Supporting Your Success on APOLO
        </motion.h2>

        {/* Description */}
        <motion.p
          className="Section7-Description hidden md:block text-base mb-10 text-black font-normal leading-6"
          variants={fadeInUpVariant}
          transition={{ delay: 0.3 }}
        >
          From verified blockchain tutors to responsive customer support and multilingual options,
          we’re here to enhance your one-on-one learning experience. Discover a platform that adapts
          to your needs every step of the way.
        </motion.p>

        {/* Feature Grid */}
        <div className="h-auto md:justify-between  max-w-6xl mx-auto mt-8 lg:mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3  gap-6 lg:gap-8 items-center justify-center">
          {section7Data.map((feature, idx) => {
            const imgSrc = require(`../../assets/images/${feature.imgName}`)

            return (
              <motion.div
                key={feature.id}
                className="Section7-Featured-Card mx-auto bg-white shadow-[6px_8px_12px_6px_rgba(247,132,48,0.25)] rounded-lg p- text-center flex flex-col items-center transition-all duration-300 hover:shadow-[6px_8px_12px_6px_rgba(247,132,48,0.35)] hover:scale-105 lg:w-[300px]  w-[280px] sm:w"
                variants={fadeInUpVariant}
                transition={{ delay: 0.4 + idx * 0.2 }}
              >
                <div className="Section7-IconBox">
                  <img src={imgSrc} alt={feature.title} className="Section7-Icon" />
                </div>
                <h4 className="Section7-Card-Title">{feature.title}</h4>
                <p className="Section7-Card-Description">{feature.description}</p>
              </motion.div>
            )
          })}
        </div>
      </div>
    </motion.section>
  )
}

export default Section7
